import * as linkify from 'linkify'

window.linkify = linkify
